import { getAllEntities } from "@/api/entity";
import { useQuery } from "@tanstack/react-query";
import { useSearchParams } from "react-router-dom";

export const FORM_ENTITIES_DEFAULT_PAGE_SIZE = 5;

type UseFormEntitiesOptions = {
  page?: number;
  size?: number;
  search?: string;
};

export const useFormEntities = (options?: UseFormEntitiesOptions) => {
  const [searchParams] = useSearchParams();

  const requestedPage = Number(searchParams.get("page"));
  const requestedSize = Number(searchParams.get("size"));
  const requestedSearch = searchParams.get("search") ?? undefined;

  const page =
    options?.page ??
    (!Number.isNaN(requestedPage) && requestedPage > 0 ? requestedPage : 1);

  const size =
    options?.size ??
    (!Number.isNaN(requestedSize) && requestedSize > 0
      ? requestedSize
      : FORM_ENTITIES_DEFAULT_PAGE_SIZE);

  const search =
    options?.search ??
    (requestedSearch && requestedSearch.trim().length > 0
      ? requestedSearch.trim()
      : undefined);

  return useQuery({
    queryFn: () => getAllEntities({ page, size, search }),
    queryKey: ["entities", { page, size, search }],
    refetchOnMount: true
  });
};
